/** Remove Bootstrap modal scroll-lock leftovers when no modal is visible. */
export function cleanupModalScrollLock() {
  if (document.querySelector(".modal.show")) return;

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
}
